import { ConfirmReplaceMediaModalPageModule } from './modals/confirm-replace-media-modal/confirm-replace-media-modal.module';
import { FooterMenuModule } from './menu/footer-menu/footer-menu.module';
import { HeaderMenuModule } from './menu/header-menu/header-menu.module';
import { TermsAndPoliciesPage } from './terms-and-policies/terms-and-policies.page';
import { TermsAndPoliciesPageModule } from './terms-and-policies/terms-and-policies.module';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { ChartsModule } from 'ng2-charts';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { IonicStorageModule } from '@ionic/storage';
import { HttpClientModule } from '@angular/common/http';
import { AddAssetToSceneComponent } from './author/add-asset-to-scene/add-asset-to-scene.component';
import { AframePipeModule } from 'angular-aframe-pipe';
import { AddAssetWithinSceneModalPageModule } from './modals/add-asset-within-scene-modal/add-asset-within-scene-modal.module';
import { AddAssetModalPageModule } from './modals/add-asset-modal/add-asset-modal.module';
import { AddEventsModalPageModule } from './modals/add-events-modal/add-events-modal.module';
import { PreviewPageModule } from './preview/preview.module';
import { ViewAssetModalPageModule } from './modals/view-asset-modal/view-asset-modal.module';
import { AddOutcomeToSceneModalPageModule } from './modals/add-outcome-to-scene-modal/add-outcome-to-scene-modal.module';
import { ViewOutcomeModalPageModule } from './modals/view-outcome-modal/view-outcome-modal.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddProjectModalPageModule } from './modals/add-project-modal/add-project-modal.module';
import { AddSceneModalPageModule } from './modals/add-scene-modal/add-scene-modal.module';
import { AddOutcomeModalModule } from './modals/add-outcome-modal/add-outcome-modal.module';
import { PageNotFoundModule } from './page-not-found/page-not-found.module';
import { MoveAssetPopoverComponent } from './popovers/move-asset-popover/move-asset-popover.component';
import { ViewAssetStorageModalModule } from './modals/view-asset-storage-modal/view-asset-storage-modal.module'
import { FileUploadInfoComponent } from './popovers/file-upload-info/file-upload-info.component';
import { AppMenuComponent } from './menu/app-menu/app-menu.component';
import { ViewTermsAndPoliciesModalPageModule } from './modals/view-terms-and-policies-modal/view-terms-and-policies-modal.module';
import { ViewProjectInfoModalPageModule } from './modals/view-project-info-modal/view-project-info-modal.module';
import { AutoplayInfoComponent } from './popovers/autoplay-info/autoplay-info.component';
import { EditResponsesPropertiesModalPageModule } from './modals/edit-responses-properties-modal/edit-responses-properties-modal.module';
import { AuthorStoryboardPopoverComponent } from './popovers/author-storyboard-popover/author-storyboard-popover.component';
import { SceneComponentsPopoverComponent } from './popovers/scene-components-popover/scene-components-popover.component';
import { ResourceDirectivesModule } from './directives/resource-directives.module'
import { ReplaceMediaPopoverComponent } from './popovers/replace-media-popover/replace-media-popover.component';
import { SceneMenuPopoverComponent } from './popovers/scene-menu-popover/scene-menu-popover.component';
import { AddQuestionsToQuestionSetModalPageModule } from './modals/add-questions-to-question-set-modal/add-questions-to-question-set-modal.module';
import { EditQuestionInQuestionSetModalPageModule } from './modals/edit-question-in-question-set-modal/edit-question-in-question-set-modal.module';
import { ViewFileModalPageModule } from './modals/view-file-modal/view-file-modal.module';
import { AddSubOutcomeToOutcomeModalPageModule } from './modals/add-sub-outcome-to-outcome-modal/add-sub-outcome-to-outcome-modal.module';
import { SceneSettingsModalPageModule } from './modals/scene-settings-modal/scene-settings-modal.module';
import { ProjectOutcomeManagementPageModule } from './modals/project-outcome-management/project-outcome-management.module';
import { NgxImageCompressService } from 'ngx-image-compress';
import { HelpModalPageModule } from './modals/help-modal/help-modal.module';
import { AddOutcomeToProjectModalPageModule } from './modals/add-outcome-to-project-modal/add-outcome-to-project-modal.module';
import { ViewOutcomeSubOutcomesModalPageModule } from './modals/view-outcome-sub-outcomes-modal/view-outcome-sub-outcomes-modal.module';
import { OutcomeActionManagementModalPageModule } from './modals/outcome-action-management-modal/outcome-action-management-modal.module';
import { AddOutcomeActionModalPageModule } from './modals/add-outcome-action-modal/add-outcome-action-modal.module';
import { ToggleVisibilityPopoverComponent } from './popovers/toggle-visibility-popover/toggle-visibility-popover.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { ProjectMenuPopoverComponent } from './popovers/project-menu-popover/project-menu-popover.component';
import { ExportProjectWizardModalPageModule } from './modals/export-project-wizard-modal/export-project-wizard-modal.module';
import { AddLearnerModalPageModule } from './modals/add-learner-modal/add-learner-modal.module';
import { QuillModule } from 'ngx-quill';
import { CalendarModule } from 'ion2-calendar';
import { UploadingStatusPopoverComponent } from './popovers/uploading-status-popover/uploading-status-popover.component';
import { DailyReportPopoverComponent } from './popovers/daily-report-popover/daily-report-popover.component';
import { MediaActionsPopoverComponent } from './popovers/media-actions-popover/media-actions-popover.component';
import { AutosavePopoverComponent } from './popovers/autosave-popover/autosave-popover.component';
import { PackagePurchaseModalPageModule } from './modals/package-purchase-modal/package-purchase-modal.module';
import { PaymentModalModule } from './modals/payment-modal/payment-modal.module';
import { AddUserModalPageModule } from './modals/add-user-modal/add-user-modal.module';
import { AddCustomerModalPageModule } from './modals/add-customer-modal/add-customer-modal.module';
import { ManageCustomerUsageModalPageModule } from './modals/manage-customer-usage-modal/manage-customer-usage-modal.module';
import { GlobalAssetPopoverComponent } from './popovers/global-asset-popover/global-asset-popover.component';
import { GlobalFileSizeAssetComponent } from './popovers/global-file-size-asset/global-file-size-asset.component';
import { TermsConditionsPopoverComponent } from './popovers/terms-conditions-popover/terms-conditions-popover.component';
import { QuestionResponseObjectEditModalPageModule } from './modals/question-response-object-edit-modal/question-response-object-edit-modal.module';
import { HelpPopoverComponent } from './popovers/help-popover/help-popover.component';
import { AssetIsBackgroundInformationPopoverComponent } from './popovers/asset-is-background-information-popover/asset-is-background-information-popover.component';
import { SceneBackgroundModalPageModule } from './modals/scene-background-modal/scene-background-modal.module';
import { AssetWizardModalPageModule } from './modals/asset-wizard-modal/asset-wizard-modal.module';
import { HeatmapModalPageModule } from './modals/heatmap-modal/heatmap-modal.module';
import { InformationPopoverComponent } from './popovers/information-popover/information-popover.component';
import { ExpandedHeatmapModalPageModule } from './modals/expanded-heatmap-modal/expanded-heatmap-modal.module'
import { BatchUploadModalPageModule } from './modals/batch-upload-modal/batch-upload-modal.module';
import { InformationPopupComponentModule } from './popovers/information-popup/information-popup.module';
import { AddAssetToSceneWizardPageModule } from './modals/add-asset-to-scene-wizard/add-asset-to-scene-wizard.module';
import { ToastrModule, ToastNoAnimation, ToastNoAnimationModule } from 'ngx-toastr';
import { ResetPasswordModalPageModule } from './modals/reset-password-modal/reset-password-modal.module';

@NgModule({
  declarations: [
    AppComponent,
    AddAssetToSceneComponent,
    MoveAssetPopoverComponent,
    FileUploadInfoComponent,
    AutoplayInfoComponent,
    AppMenuComponent,
    AuthorStoryboardPopoverComponent,
    SceneComponentsPopoverComponent,
    ReplaceMediaPopoverComponent,
    ProjectMenuPopoverComponent,
    SceneMenuPopoverComponent,
    ToggleVisibilityPopoverComponent,
    UploadingStatusPopoverComponent,
    DailyReportPopoverComponent,
    MediaActionsPopoverComponent,
    AutosavePopoverComponent,
    TermsConditionsPopoverComponent,
    GlobalAssetPopoverComponent,
    GlobalFileSizeAssetComponent,
    HelpPopoverComponent,
    AssetIsBackgroundInformationPopoverComponent,
    InformationPopoverComponent,
  ],
  entryComponents: [
    AddAssetToSceneComponent,
    MoveAssetPopoverComponent,
    AutoplayInfoComponent,
    FileUploadInfoComponent,
    AuthorStoryboardPopoverComponent,
    SceneComponentsPopoverComponent,
    ReplaceMediaPopoverComponent,
    ProjectMenuPopoverComponent,
    SceneMenuPopoverComponent,
    ToggleVisibilityPopoverComponent,
    UploadingStatusPopoverComponent,
    DailyReportPopoverComponent,
    GlobalAssetPopoverComponent,
    GlobalFileSizeAssetComponent,
    MediaActionsPopoverComponent,
    AutosavePopoverComponent,
    TermsConditionsPopoverComponent,
    HelpPopoverComponent,
    AssetIsBackgroundInformationPopoverComponent,
    InformationPopoverComponent,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    AframePipeModule,
    AddAssetWithinSceneModalPageModule,
    AddAssetModalPageModule,
    AddOutcomeToSceneModalPageModule,
    AddProjectModalPageModule,
    AddSceneModalPageModule,
    AddEventsModalPageModule,
    AddOutcomeModalModule,
    IonicStorageModule.forRoot(),
    ViewAssetModalPageModule,
    PreviewPageModule,
    ViewOutcomeModalPageModule,
    NgxPaginationModule,
    FormsModule,
    ReactiveFormsModule,
    PageNotFoundModule,
    ViewAssetStorageModalModule,
    ViewTermsAndPoliciesModalPageModule,
    HeaderMenuModule,
    FooterMenuModule,
    ViewProjectInfoModalPageModule,
    ResourceDirectivesModule,
    EditResponsesPropertiesModalPageModule,
    ConfirmReplaceMediaModalPageModule,
    AddQuestionsToQuestionSetModalPageModule,
    EditQuestionInQuestionSetModalPageModule,
    ViewFileModalPageModule,
    AddSubOutcomeToOutcomeModalPageModule,
    SceneSettingsModalPageModule,
    ProjectOutcomeManagementPageModule,
    HelpModalPageModule,
    AddOutcomeToProjectModalPageModule,
    ViewOutcomeSubOutcomesModalPageModule,
    AddLearnerModalPageModule,
    OutcomeActionManagementModalPageModule,
    AddOutcomeActionModalPageModule,
    ExportProjectWizardModalPageModule,
    QuestionResponseObjectEditModalPageModule,
    ColorPickerModule,
    ChartsModule,
    QuillModule,
    CalendarModule,
    PackagePurchaseModalPageModule,
    PaymentModalModule,
    AddUserModalPageModule,
    AddCustomerModalPageModule,
    ManageCustomerUsageModalPageModule,
    SceneBackgroundModalPageModule,
    AssetWizardModalPageModule,
    HeatmapModalPageModule,
    ExpandedHeatmapModalPageModule,
    BatchUploadModalPageModule,
    AddAssetToSceneWizardPageModule,
    ResetPasswordModalPageModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-right',
    }),
    ToastNoAnimationModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: false,
    }),
  ],
  exports: [],
  providers: [
    NgxImageCompressService,
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
